import { Spinner, Switch } from "@heroui/react"
import PropTypes from "prop-types"

const CustomSwitch = ({ 
  title, 
  children, 
  isLoading, 
  isSelected, 
  handleChange, 
  ...rest 
}) => (
  <div className="flex items-center justify-between">
    <div>
      <p className="font-semibold">{title}</p>
      
      <div className="text-content2-foreground">
        {children}
      </div>
    </div>
    
    {isLoading ? <Spinner /> : <Switch isSelected={isSelected} onValueChange={(isSelected) => handleChange(isSelected)} color="success"  {...rest} />}
  </div>
)

CustomSwitch.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node,
  isLoading: PropTypes.bool,
  isSelected: PropTypes.bool.isRequired,
  handleChange: PropTypes.func.isRequired,
}

export default CustomSwitch